export default "__VITE_ASSET__BFKjyIq3__"